import { PaywallAuthErrorCodes, PremiumPaywallSignModes, SiteLinks, PaywallPlans } from "../../../../../global/paywall/paywallInterfaces";
import { HyperLinkBuilder } from "../../../../commonComponents/inline/hyperLink";
import { PremiumPaywallState } from "../../desktop/premiumPaywallDesktop";
import { getNewlinkTargetProperties } from "../../../ynet1280/ynetShops/data/ynetshopsData";


interface PremiumPaywallMobileSignupEmailProps {
  emailOrPhone: string
  agreesTerms: boolean
  setEmailOrPhone: (emailOrPhone: string) => void
  setAgreesTerms: (agreesTerms: boolean) => void
  setMode: (state: PremiumPaywallState) => void
  loginWithGoogle: () => void
  loginWithApple: () => void
  sendMail: () => void
  authError: string
  setAuthError: (error: PaywallAuthErrorCodes) => void;
}


const errorMessagesFront: Partial<Record<PaywallAuthErrorCodes, string>> = {
  [PaywallAuthErrorCodes.INVALID_EMAIL]: 'כתובת דוא"ל אינה תקינה',
  [PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT]: `חובה לאשר את `,
};

const errorMessagesServer: Partial<Record<PaywallAuthErrorCodes, string>> = {
  [PaywallAuthErrorCodes.EMAIL_ALREADY_EXISTS]: `כתובת הדוא"ל כבר קיימת במערכת`,
  [PaywallAuthErrorCodes.FAILED_TO_SEND_OTP]: "אירעה שגיאה במערכת, אנא נסו שוב מאוחר יותר",
  [PaywallAuthErrorCodes.ALREADY_SIGNED]: "משתמש קיים במערכת",
  [PaywallAuthErrorCodes.OTP_MAX_ATTEMPTS]: "חרגת ממספר בקשות אימות. יש לפנות לשירות לקוחות",
}

declare const window: Window & {
  PAYWALL_PLANS: PaywallPlans
  PAYWALL_SITE_LINKS: SiteLinks;
}

export const PremiumPaywalllMobileSignupEmail = (props: PremiumPaywallMobileSignupEmailProps) => {

  const { emailOrPhone, setEmailOrPhone, agreesTerms, setAgreesTerms, loginWithApple, loginWithGoogle, setMode, sendMail, authError, setAuthError } = props

  const handleMailChange = (e) => {
    setEmailOrPhone(e.target.value)
    if (e.target.value.length === 0 && authError) {
      setAuthError(null);
    }
  }

  const handleAgreeChange = (e) => {
    setAgreesTerms(e.target.checked)
    if (e.target.checked) {
      setAuthError(null);
      const handleAgreeTerms = new Event("handleAgreeTerms")
      document.dispatchEvent(handleAgreeTerms);
    }
  }

  const handleSendMail = () => {
    sendMail()
     const accountSendMailAnalytics = new CustomEvent("accountSendMailAnalytics",  { detail: { label: "signup" } })
      document.dispatchEvent(accountSendMailAnalytics);
  }

  const handlePressKey = (e) => {
    if (e.key === 'Enter') {
      handleSendMail();
    }
  }

  const handleThirdPartyLogin = (loginMethod: () => void) => {
    if (agreesTerms) {
      loginMethod();
      const handleThirdPartyLogin = new CustomEvent("handleThirdPartyLogin", { detail: { loginMethod: loginMethod === loginWithGoogle ? "google" : "apple", type: "signup" } });
      document.dispatchEvent(handleThirdPartyLogin);

    } else {
      setAuthError(PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT);
    }
  }

const loginEvent =(mode)=>{
    setMode({ mode: mode })    
    const loginButtonEvent = new CustomEvent("loginButtonEvent",   { detail: {  mode: mode } })
    document.dispatchEvent(loginButtonEvent);
}
const handleNewspaperRegister = () => {
    setMode({ mode: 'signIn', isNewspaper: true })
    const newspaperRegisterEvent = new CustomEvent("handleNewspaperRegister")
    document.dispatchEvent(newspaperRegisterEvent);
}

  const handleEmailReset = () => {
    setEmailOrPhone('');
    setAuthError(null);
  }

  const termsUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.terms : '';
  const privacyUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.privacy : '';
  const targetLink = getNewlinkTargetProperties();


  return (
    <div className="premium-paywall-mobile-signup-email">
      <h1 className="title">יצירת חשבון</h1>
      <div className="subtitle">הזינו את כתובת הדוא"ל</div>
      <div className={`email-signin ${authError && authError === PaywallAuthErrorCodes.INVALID_EMAIL ? 'error' : ''}`}>
        <input onKeyDown={handlePressKey} value={emailOrPhone} onChange={handleMailChange} type="email" placeholder='הקלידו כתובת דוא"ל' />
        {emailOrPhone && <div className="reset-icon" onClick={handleEmailReset}></div>}
        <p className="error-text">{authError === PaywallAuthErrorCodes.INVALID_EMAIL ? errorMessagesFront[authError] : errorMessagesServer[authError]}</p>
      </div>

          <div className="buttons-container">
        <button className="button-base continue" disabled={!emailOrPhone.length} onClick={handleSendMail}>המשך</button>
      </div>

      <div className="separator">
        <div className="line" />
        <span className="text">או באמצעות</span>
        <div className="line" />
      </div>

      <div className="social-signin">
        <button className="social-button google-btn" onClick={() => handleThirdPartyLogin(loginWithGoogle)}><span>גוגל</span></button>
        <button className="social-button apple-btn" onClick={() => handleThirdPartyLogin(loginWithApple)}><span>אפל</span></button>
      </div>

      <div className={`terms ${authError && authError === PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT ? 'error' : ''}`}>
        <div className="inner-container">
          <input type="checkbox" checked={agreesTerms} onChange={handleAgreeChange} />
          <span className="text">מסכים/ה ל<HyperLinkBuilder linkTarget={targetLink} href={termsUrl}>תנאי השימוש</HyperLinkBuilder>, <HyperLinkBuilder linkTarget={targetLink} href={privacyUrl}>מדיניות פרטיות</HyperLinkBuilder>, וקבלת פניות שיווקיות כולל טלפוניות, הודעות תפעוליות ימשיכו להישלח בתקופת המינוי גם לאחר הסרתי מרשימת מדוורים</span>
        </div>
                <p className="error-text">
                  {authError === PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT ? (
                    <div><span dangerouslySetInnerHTML={{ __html: errorMessagesFront[authError] }} /> <HyperLinkBuilder linkTarget={targetLink} href={termsUrl}>תנאי השימוש</HyperLinkBuilder></div>
                  ) : <span> </span>}
                </p>
      
      </div>

  

      <div className="login">
        <div>כבר מנויים? <button type="button" onClick={() => loginEvent('signIn')}>כניסה</button></div>
      </div>

      <div className="newspaper-users" >
        <div><span>מנויים לעיתון</span> <span className="yedioth-label"></span></div>
        <div onClick={() => handleNewspaperRegister()} className="newspaper-register-text">צרו חשבון ל-<div className="yedioth-plus-label"></div>ללא עלות</div>
      </div>
    </div>
  )
}
